import { z } from "zod"

import { DepartmentSchema } from "@/common/schemas/department"
import { ProfessorSchema } from "@/common/schemas/professor"
import { TimeBlockSchema } from "@/common/schemas/timeblock"

const ClassTimeSchema = TimeBlockSchema.extend({
    buildingCode: z.string(),
    buildingName: z.string(),
    roomName: z.string(),
})

const ExamTimeSchema = TimeBlockSchema.extend({
    str: z.string(),
})

export const LectureSchema = z.object({
    id: z.number().int(),
    courseId: z.number().int(),
    classNo: z.string(),
    name: z.string(),
    subtitle: z.string(),
    code: z.string(),
    department: DepartmentSchema,
    type: z.string(),
    limitPeople: z.number().int(),
    numPeople: z.number().int().nullable(),
    classDuration: z.number().int(),
    expDuration: z.number().int(),
    credit: z.number().int(),
    creditAU: z.number().int(),
    averageGrade: z.number().min(0).max(15),
    averageLoad: z.number().min(0).max(15),
    averageSpeech: z.number().min(0).max(15),
    isEnglish: z.boolean(),
    professors: z.array(ProfessorSchema),
    classes: z.array(ClassTimeSchema),
    examTimes: z.array(ExamTimeSchema),
})

export type ClassTime = z.infer<typeof ClassTimeSchema>
export type ExamTime = z.infer<typeof ExamTimeSchema>
export type Lecture = z.infer<typeof LectureSchema>
